/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*



(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

*/

(function () {
  document.addEventListener("theme:cart:change", function (event) {
    consenTag.trigger({
      event: "nextstep",
    });

    var variantJustAdded = event.detail.cart.items[0];
    console.log(variantJustAdded);

    // FB pixel variant
    thisPrice = variantJustAdded.price / 100;

    console.log("FB pixel - variant ID: " + variantJustAdded.id);
    fbq("track", "AddToCart", {
      content_ids: variantJustAdded.id,
      content_type: "product",
      currency: "GBP",
      value: thisPrice,
    });
  });

  document
    .querySelector(".cart-trigger")
    .addEventListener("click", function (event) {
      consenTag.trigger({
        event: "nextstep",
      });
      console.log(consenTag);
    });

  // Product subscription & one-time purchase tabs
  const enableSubscriptionTabs = function (section) {
    const rechargeElement = section.querySelector("[data-recharge-widget]");
    const pricingTabs = section.querySelectorAll("[data-pricing-tab]");
    const productForm = section.querySelector("[data-product-form-outer]");
    const boxPrice = document.querySelector(".box-and-sachet-details-pdp");
    if (typeof rechargeElement !== "undefined" && rechargeElement !== null) {
      // Set initial class on product form parent
      if (
        rechargeElement.querySelector(`input[value="autodeliver"]`).checked ===
        true
      ) {
        productForm.classList.add(`selected--autodeliver`);
      }

      // Listen for clicks on pricing tabs
      pricingTabs.forEach(function (tab) {
        tab.addEventListener("click", function (e) {
          pricingTabs.forEach(function (tab) {
            tab.classList.remove("active-tab");
          });
          e.currentTarget.classList.add("active-tab");

          rechargeElement
            .querySelector(
              `input[value="${e.currentTarget.dataset.pricingTab}"]`
            )
            .click();

          if (e.currentTarget.dataset.pricingTab === "autodeliver") {
            productForm.classList.add(`selected--autodeliver`);

            // Set first variant to selected when autodeliver is selected
            productForm
              .querySelector(`.radio__button:first-of-type input`)
              .click();

            let thisSachetPriceHTML =
              productForm.querySelector(".sachet-price-pd").textContent;
            let thisBoxPriceHTML = productForm.querySelector(
              ".sachet-price-pd-box"
            ).textContent;
            var thisSachetPrice = thisSachetPriceHTML.replace(/^\D+/g, "");
            var thisBoxPrice = thisBoxPriceHTML.replace(/^\D+/g, "");

            var thisSachetPriceDiscounted =
              thisSachetPrice - (thisSachetPrice / 100) * 20;
            var thisSachetPriceDiscounted = parseFloat(
              thisSachetPriceDiscounted
            ).toFixed(2);

            var thisBoxPriceDiscounted =
              thisBoxPrice - (thisBoxPrice / 100) * 20;
            var thisBoxPriceDiscounted = parseFloat(
              thisBoxPriceDiscounted
            ).toFixed(2);

            productForm.querySelector(".sachet-price-pd").innerHTML =
              "Price per sachet: £" + thisSachetPriceDiscounted;
            productForm.querySelector(".sachet-price-pd-box").innerHTML =
              "Price per box: £" + thisBoxPriceDiscounted;
          } else {
            originalVariantSachetPrice =
              productForm.querySelector(".sachet-price-pd").dataset
                .pricePerSachet;
            originalVariantBoxPrice = productForm.querySelector(
              ".sachet-price-pd-box"
            ).dataset.pricePerBox;

            // rewrite the first variant's sachet count
            productForm.querySelector(".sachet-price-pd").innerHTML =
              "Price per sachet: £" + originalVariantSachetPrice;
            productForm.querySelector(".sachet-price-pd-box").innerHTML =
              "Price per box: £" + originalVariantBoxPrice;

            productForm.classList.remove(`selected--autodeliver`);
          }
        });
      });
    }
  };

  const productForms = document.querySelectorAll("[data-product-form-outer]");

  productForms.forEach(function (productForm) {
    const section = productForm.closest(".shopify-section");
    enableSubscriptionTabs(section);
  });

  // Sticky product bar on product pages
  const stickyProductBar = document.querySelector("[data-sticky-product-bar]");
  const productButtons = document.querySelector("[data-buttons-wrapper]");
  // Move Smile icon up - getting simle badge element
  var smile = document.getElementsByClassName("smile-launcher-frame-container");
  // Check if sticky bar exists on page
  if (typeof stickyProductBar !== "undefined" && stickyProductBar !== null) {
    // Check if product form buttons are visible
    isInViewport = (element) => {
      const bounding = element.getBoundingClientRect();
      if (bounding.top >= 0 && bounding.bottom <= window.innerHeight) {
        return true;
      } else {
        return false;
      }
    };

    // Hide/show sticky product bar on scroll
    document.addEventListener("theme:scroll", (e) => {
      let direction = "down";
      if (e.detail.up == true) {
        direction = "up";
      }

      if (direction == "down" && isInViewport(productButtons)) {
        stickyProductBar.classList.add("product__sticky-bar--visible");
        // adding class to Move Smile icon up
        if (smile[0]) {
          smile[0].classList.add("smile_move_up");
        }
      } else if (direction == "up" && isInViewport(productButtons)) {
        stickyProductBar.classList.remove("product__sticky-bar--visible");
        // removing class to Move Smile icon down
        if (smile[0]) {
          smile[0].classList.remove("smile_move_up");
        }
      }
    });
  }
})();
const cartNoteTrigger = document.querySelector(".cart-note-wrapper a");
const cartNote = document.querySelector(".cart-note");

if (cartNoteTrigger) {
  cartNoteTrigger.addEventListener("click", function (e) {
    e.preventDefault();

    if (cartNote.classList.contains("hide")) {
      cartNote.classList.remove("hide");
      cartNoteTrigger.classList.add("open");
    } else {
      cartNote.classList.add("hide");
      cartNoteTrigger.classList.remove("open");
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // FAQ page hide/show
  document.querySelectorAll(".faq-product-icon img").forEach((item) => {
    item.addEventListener("click", function () {
      // get the class name of the item clicked
      let thisClass = item.className;

      // hide all FAQ sections
      document
        .querySelectorAll(".shopify-section.page-faqs")
        .forEach((image) => {
          image.classList.remove("show");
        });

      // now show the FAQ section relevant to what was just clicked
      document
        .querySelector(".shopify-section.page-faqs." + thisClass)
        .classList.add("show");

      // now slide down to reveal the FAQs
      const offsetTop = document.querySelector(
        ".shopify-section.page-faqs." + thisClass
      ).offsetTop;

      scroll({
        top: offsetTop - 170,
        behavior: "smooth",
      });
    });
  });
});

// checkout button hijack

function showCheckoutGuestPopup(event) {
  event.preventDefault();

  // show the popup
  var popup = document.querySelector(".guest-checkout-popup-wrapper");
  popup.classList.add("show");

  return false;
}

// only add the eventListeners on the cart page
var element = document.getElementById("checkout_guest_popup");
if (typeof element != "undefined" && element != null) {
  // event handler for guest checkout popup
  document
    .getElementById("checkout_guest_popup")
    .addEventListener("click", showCheckoutGuestPopup);

  // event handler for guest checkout button
  document
    .getElementById("guest-submit")
    .addEventListener("click", function () {
      document.getElementById("guest-checkout-button").click();
    });
}

/*
const modal = document.querySelector("dialog")

if(modal){

  document.querySelector(".learn-more-trigger").addEventListener("click", ( e ) => {
    e.preventDefault();
    modal.showModal();
    document.querySelector('body').classList.add("blur")
  });
  
  const closeBtns = document.querySelectorAll(".close");
  
  closeBtns.forEach( (lnk) => {
    lnk.addEventListener("click", ( e ) => {
      e.preventDefault();
      document.querySelector('body').classList.remove("blur");
      modal.close();
    })
  });
  
  // Close dialog
  const dialog = document.querySelector("dialog");
  dialog.addEventListener("click", ( e ) => {
    if (e.target === dialog) {
      modal.close();
       document.querySelector('body').classList.remove("blur");
    }
  
  });
  

}

*/

// Customer register confirm password.
window.onload = function () {
  $(function () {
    $("#password_confirmation").on("input", function (e) {
      if ($("#CreatePassword").val() === $("#password_confirmation").val()) {
        //alert('Password Good!!');
        $(".submit_form").removeAttr("disabled");
        $(".password-match").css("display", "none");
        e.preventDefault();
      } else {
        $(".password-match").css("display", "block");
        $(".submit_form").attr("disabled", true);
      }
      $(this).focus();
    });
  });
};

// Open cart drawer after add to cart button is clicked

function show_cart() {
  document.querySelector(".site-header__cart").click();
}

var buttonEl = document.getElementById("product__add_button");
var sticky_buttonEl = document.getElementById("product__add_button_sticky");
if (buttonEl) {
  buttonEl.onclick = function () {
    setTimeout(show_cart, 1000);
  };
}
if (sticky_buttonEl) {
  sticky_buttonEl.onclick = function () {
    setTimeout(show_cart, 1000);
  };
}

/*qty selector price update for subscription product - Sol */

var productFormEl = document.querySelector(".product__form__outer");

if (productFormEl) {
  //get subscription product price
  var one_unit_price = document.getElementById("sub_value").innerHTML;

  //quantity selector plus button
  var plus_qty_click = document.getElementsByClassName(
    "quantity__button--plus"
  );

  for (var i = 0; i < plus_qty_click.length; i++) {
    var plus_qty_click = plus_qty_click[i];
    plus_qty_click.onclick = function () {
      //get quantity
      var qty = document.getElementById("product_quantity").value;
      var total = one_unit_price * qty;
      change_price = document.getElementsByClassName(
        "product__recurring-price"
      );
      change_price[i].innerText = "£" + total;
      document.getElementById("sub_main_price").style.display = "none";
      document.getElementById("sub_unit_price").style.display = "line-through";
      document.getElementById("sub_unit_price").innerText = "£" + total;
    };
  }

  //quantity selector minus button
  var minus_qty_click = document.getElementsByClassName(
    "quantity__button--minus"
  );
  for (var i = 0; i < minus_qty_click.length; i++) {
    var minus_qty_click = minus_qty_click[i];
    minus_qty_click.onclick = function () {
      //get quantity
      var qty = document.getElementById("product_quantity").value;
      var total = one_unit_price * qty;
      change_price = document.getElementsByClassName(
        "product__recurring-price"
      );
      change_price[i].innerText = "£" + total;
      document.getElementById("sub_main_price").style.display = "none";
      document.getElementById("sub_unit_price").style.display = "line-through";
      document.getElementById("sub_unit_price").innerText = "£" + total;
    };
  }
}

// Add to cart on collection pages / featured collections

// for collection pages
document.querySelectorAll(".add-to-cart").forEach((button) => {
  button.addEventListener("click", function (e) {
    e.preventDefault();

    var thisVariantId = e.target.dataset.variantId;
    var thisVariantQty = 1;

    const data = {
      items: [
        {
          quantity: thisVariantQty,
          id: thisVariantId,
        },
      ],
    };

    console.log(data);

    addItemToCart(data, e);
  });
});

function addItemToCart(data, e) {
  const basketHeaderLink = document.querySelector(".site-header__cart");
  const addingItems = e.target.parentNode.parentNode.querySelector(
    ".cart-status .adding"
  );
  const itemsAdded = e.target.parentNode.parentNode.querySelector(
    ".cart-status .added"
  );
  // const productInfoEl = e.target.parentNode.closest(".product-grid-item").querySelector('.btn_product_info');
  // itemsAdded.classList.remove("show");
  // addingItems.classList.add("show");
  // productInfoEl.classList.add("hide");

  const cartCountHandle = document.querySelector("span.cart-count");
  var cartCount = cartCountHandle.innerText;

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (response.ok) {
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            detail: {
              cart: response.data,
            },
            bubbles: true,
          })
        );
        cartCountHandle.innerHTML = +cartCount + +data["items"][0]["quantity"];
        // addingItems.classList.remove("show");
        // itemsAdded.classList.add("show");
        basketHeaderLink.click();
      } else {
        response.json().then(function (content) {
          addingItems.classList.remove("show");
          itemsAdded.innerHTML = content.description;
          itemsAdded.classList.add("show", "error");
        });
      }
    })
    .catch((error) => {
      console.log("Error:", error);
    });
}

// close if clicked outside
window.onload = function () {
  var popup = document.querySelector(".guest-checkout-popup-wrapper");
  document.onclick = function (e) {
    if (e.target.classList.contains("guest-checkout-popup-wrapper")) {
      popup.classList.remove("show");
    }
  };

  const onetimeDiv = document.querySelector('[data-pricing-tab="onetime"]');
  const autodeliverDiv = document.querySelector(
    '[data-pricing-tab="autodeliver"]'
  );
  const onetimeCheckbox = onetimeDiv.querySelector("input[type='checkbox']");
  const autodeliverCheckbox = autodeliverDiv.querySelector(
    "input[type='checkbox']"
  );

  onetimeDiv.addEventListener("click", function () {
    onetimeCheckbox.checked = true;
    autodeliverCheckbox.checked = false;
    const variantoptn = document.querySelector(".radio__fieldset");
    const varianttitle = document.querySelector(".onetime");
    const autodeliverttitle = document.querySelector(".autodeliver");
    varianttitle.style.order = "0";
    variantoptn.style.order = "1";
    autodeliverttitle.style.order = "2";
    console.log(variantoptn);
    document.getElementsByName("selling-plan-group")[0].checked=true;
    document.querySelector('.product__subs__plans input[name="selling_plan"]').checked = false;
    console.log("diarmuid 1");
  });

  autodeliverDiv.addEventListener("click", function () {
    onetimeCheckbox.checked = false;
    autodeliverCheckbox.checked = true;
    const variantoptn = document.querySelector(".radio__fieldset");
    const varianttitle = document.querySelector(".onetime");
    const autodeliverttitle = document.querySelector(".autodeliver");
    varianttitle.style.order = "0";
    variantoptn.style.order = "2";
    autodeliverttitle.style.order = "1";
    console.log(variantoptn);
    document.getElementsByName("selling-plan-group")[1].checked=true;
    
    document.querySelector('.product__subs__plans input[name="selling_plan"]').checked = true;
    
    console.log("diarmuid 2");
  });
};

// const accordTitles = document.querySelectorAll('.product-accordion .accordion__title');
// if (accordTitles) {
//   accordTitles.forEach((accordTitle) => {
//     accordTitle.addEventListener('click', () => {
//       if (!accordTitle.classList.contains('ingredient-modal-toggle')) {
//         accordTitle.classList.toggle('accordion-is-open');
//         const nearestSibling = accordTitle.nextElementSibling;
//         if (nearestSibling) {
//           if (nearestSibling.style.display === 'block') {
//             nearestSibling.style.display = 'none';
//           } else {
//             nearestSibling.style.display = 'block';
//           }
//         }
//       } else if (accordTitle.classList.contains('ingredient-modal-toggle')) {
//         const el = accordTitle.querySelector('.ingredient-modal');
//           el.toggle('is-visible');
//       }
//     });
//   });
// }

// // Quick & dirty toggle to demonstrate modal toggle behavior
// $('.ingredient-modal-toggle').on('click', function(e) {
//   e.preventDefault();
//   $('.ingredient-modal').toggleClass('is-visible');
// });

// what's inside tab and slider section

/*
const whatsinsidePage = document.querySelector(".inside-ingredients");
const whatsinsideContent = document.querySelectorAll('.inside_ingredients_main_service');
const tab = document.querySelectorAll('.inside_ingredients_main_head');
const slider = document.querySelector('.inside_ingredients_slider');



function hideTabContent() {
  whatsinsideContent.forEach(item => {
    item.style.display = 'none';
  });
  tab.forEach(item => {
    item.classList.remove('is-selected');
  });
}
 
function showTabContent(i = 0) {
  
      whatsinsideContent[i].style.display = 'block';
    
  
  tab[i].classList.add('is-selected');

}


if(whatsinsidePage){

  hideTabContent();
  showTabContent();

  slider.addEventListener("click", (e) => {
    const target = e.target
    if (target) {
       tab.forEach((item, i) => {
                  if (target == item) {
                      hideTabContent();
                      showTabContent(i);
                  }
              })
    }
  });

}*/
